import {Component, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {NotificationService} from 'src/app/common/services/notifications.service';
import {ProdutosService} from '../services/produtos.service';

@Component({
    /* tslint:disable:component-selector */
    selector: '[store-product-admin]',
    templateUrl: './product-admin.component.html',
    styleUrls: ['./product-admin.component.scss']
})
export class ProductAdminComponent implements OnInit, OnDestroy {

    product: any;

    private routerSubscription: Subscription;

    constructor(
        private produtosService: ProdutosService,
        public sanitizer: DomSanitizer,
        private router: Router,
        private route: ActivatedRoute,
        private notificationService: NotificationService
    ) {

        const token: string = this.produtosService.getToken();
        if (token && token.length) {
            this.routerSubscription = this.router.events.subscribe((val) => {
                if (val instanceof NavigationEnd) {
                    const id: string = String(this.route.snapshot.params.id);
                    const type: string = String(this.route.snapshot.params.type);
                    if (type === 'draft') {
                        const draft: any = this.produtosService.findDraft(id);
                        this.product = draft;
                        this.product.ehPublicado = false;
                        this.controlHeaderStyle();
                    } else {
                        this.produtosService.getProduct(id).then(result => {
                            if (result) {
                                this.product = result;
                                this.product.ehPublicado = true;
                                this.controlHeaderStyle();
                            } else {
                                this.notificationService.publish({
                                    type: 'danger',
                                    description: 'Não foi possível abrir o produto para edição'
                                });
                                this.router.navigate(['./admin']);
                            }
                        });
                    }
                }
            });
        } else {
            this.router.navigate(['./admin']);
        }

    }

    ngOnInit() {

    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }

    private controlHeaderStyle(): void {
        setTimeout(() => {
            const wrapper = document.getElementById('productWrapper');
            if (wrapper) {
                wrapper.addEventListener('scroll', () => {
                    if (wrapper.scrollTop === 0) {
                        document.querySelector('header').classList.remove('on-scroll');
                    } else {
                        document.querySelector('header').classList.add('on-scroll');
                    }
                });
            }
        }, 500);
    }

}
